import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceSmilingHands } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

const StyledDiv = styled.div`
  text-align: center;
  margin-top: ${SPACERS.large};
  .icon {
    margin-bottom: ${SPACERS.medium};
  }
`;

const NoOutstandingTasks: React.FC = () => {
  const [showLoading, setShowLoading] = useState<boolean>(true);

  useEffect(() => {
    window.setTimeout(() => {
      setShowLoading(false);
    }, 1000);
  }, [setShowLoading]);

  if (showLoading) {
    return <TrueImpactLoading />;
  }

  return (
    <StyledDiv>
      <FontAwesomeIcon
        icon={faFaceSmilingHands}
        color={COLORS.ctaPrimary}
        size="4x"
        className="icon"
      />
      <TrueImpactText variant="heading-subheading">
        All quiet here!
      </TrueImpactText>
      <TrueImpactText>
        You don’t have any tasks due at the moment.
        <br />
        You can see the rest of your team’s tasks below.
      </TrueImpactText>
    </StyledDiv>
  );
};

export default NoOutstandingTasks;
